import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-vmware-monitoring-tool',
  imports: [RouterModule, FeatureHero],
  templateUrl: './vmware-monitoring-tool.html',
  styleUrl: './vmware-monitoring-tool.scss',
})
export class VmwareMonitoringTool {

}
